// @vendors
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

const WalletEmptyState = (handleRetry) => {
    const lostConnectionFirstLine = formatText(
        'broker-myWalletLostConnectionFirstLine'
    );
    const retryButton = (
        <OKButton id="btn_accountLastMovements_retry" onClick={handleRetry}>
            <FormattedText value="broker-retry" />
        </OKButton>
    );

    return <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
}

module.exports = WalletEmptyState;